"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.suggest = void 0;
var MqlParser_1 = require("./MqlParser");
var suggestJoiner = function () { return ({ type: 'joiner' }); };
var suggestOperator = function () { return ({ type: 'operator' }); };
var suggestIdentifier = function () { return ({ type: 'identifier' }); };
var suggestValue = function (context) { return ({ type: 'value', context: context }); };
var suggestNone = function () { return ({ type: 'none' }); };
var didExpect = function (err, type, value) {
    if ('expected' in err && Array.isArray(err.expected)) {
        return err.expected.some(function (expected) { return (expected.type === type &&
            (expected.text === value || expected.description === value)); });
    }
    return false;
};
var suggest = function (fragment) {
    fragment = fragment.trim().toLowerCase();
    if (!fragment) {
        return suggestIdentifier();
    }
    try {
        MqlParser_1.MqlParser.parse(fragment);
        // If compiles successfully, then suggest a joiner
        return suggestJoiner();
    }
    catch (err) {
        if (err instanceof Error) {
            if (didExpect(err, 'literal', '=')) {
                return suggestOperator();
            }
            else if (didExpect(err, 'other', 'string') && fragment.match(/\w+\s*=\s*$/)) {
                var _a = __read(fragment.match(/\b(\w+)\s*=\s*$/) || [], 2), _ = _a[0], identifier = _a[1];
                return suggestValue(identifier);
            }
            else if (fragment.match(/(and|or)$/)) {
                return suggestIdentifier();
            }
        }
    }
    return suggestNone();
};
exports.suggest = suggest;
